export function validateInput(value: number, maxValue: number) {
  if (value == null || value < 0) {
    return 0;
  }
  if (value > maxValue) {
    return maxValue;
  }
  return value;
}
